import { IKeyValuePair } from '@kurtosys/types/common/IKeyValuePair.js';

export function getGlobalValue(mapping: Partial<IKeyValuePair>): unknown {
	if (mapping.value) {
		return mapping.value;
	}
	// Stubbed at the moment
	return mapping.key;
}
